import { forEach, map, remove, replace } from 'lodash'
import routes from '../routes/routes'
import adminRoutes from '../routes/adminRoutes'

export default {
  publicRoutePaths () {
    return [
      routes.signIn,
      routes.resetPassword,
      routes.updatePassword,
      routes.terms,
      routes.subscribe,
      routes.paymentConfirmation,
      routes.trial,
      routes.trialCustomLabel,
      routes.trialProductionCustomLabel,
      routes.emailVerify
    ]
  },

  routePaths () {
    const paths = map(routes, route => route)
    remove(paths, path => path === routes.signIn)
    return paths
  },

  adminRoutePaths () {
    return map(adminRoutes, route => route)
  },

  replaceParams (url: string, params: object) {
    forEach(params, (value, name) => {
      url = replace(url, `{${name}}`, value)
    })
    return url
  }
}
